import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6gjfy9yksc: FaireBrandEntity = {
  token: "b_6gjfy9yksc",
  type: "brand",
  name: "Helmsie",
  avatarUrl:
    "https://cdn.faire.com/fastly/c94b1c1ffe13f426830e205471646f91b348df3d27e3c33d0f36c757256a5038.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/014ed76c35556fea6330a0487b949e41328a77e208f1e0031d75934dcc21a5f0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c94b1c1ffe13f426830e205471646f91b348df3d27e3c33d0f36c757256a5038.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/014ed76c35556fea6330a0487b949e41328a77e208f1e0031d75934dcc21a5f0.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 64,
  isTopShop: true,
  isInsider: true,
  description:
    'Helmsie is a children’s brand based in Georgia. Bouncing babies on knees in Atlanta one day, cofounders and friends Sarah Howell and Karla Pruitt dreamed up Helmsie. They have always agreed that the very best goods are practical and pretty, something both mama and baby enjoy. Helmsie\'s online retail store carries the goods they dreamed up, as do over 600 retail stores across the US and abroad. Helmsie has also designed products for other companies who make marvelous things as well, like hand-screen printed wallpaper for Hygge & West and beautifully patterned goods for Creative Co-Op.\n\nHelmsie products are thoughtfully and purposefully created with both adults and littles in mind. At Helmsie, you will find products filled with whimsy and joy that the modern momma (or dad!) would be proud to have in their home. Helmsie’s collection boasts of unique sets of hand drawn flashcards, fine art prints and posters, and their popular "Mama and Me" line. In addition, their brand new "Mama and Me" sippy cup and mug set, accessories line and floor puzzle.\n\nHelmsie products are designed with both the parent and little in mind, something they both can love together. It doesn\'t have to be one way or the other and that is where Helmsie shines. \n',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:39.288Z",
    importedBy: "entity-db-cli",
  },
};
